import { navigateTo } from 'gatsby-link';
import PropTypes from 'prop-types';
import React from 'react';
import { Element } from 'react-scroll';
import Blocks from '../components/Blocks';
import Link from '../components/Link';
import { sanitizeContent, scrollToElement } from '../utils';
import styles from './page.home.module.css';



const Home = ({ pathContext: { subparts, images } }) => {
  const { ueberuns, verwaltung, verkauf } = sanitizeContent(
    subparts,
    'ueberuns',
    'verwaltung',
    'verkauf',
    'dataprivacy',
    'dataprocessing'
  );

  const {
    header: [{ image: headerImage }],
    verkauf: [{ image: verkaufImage }],
    verwaltung: [{ image: verwaltungImage }]
  } = sanitizeContent(images, 'header', 'verkauf', 'verwaltung');

  return (
    <div>
      <Element name="home">
        <div className={styles.headerImage} style={{ backgroundImage: `url(${headerImage.file.url})` }} />
        <div className={styles.wrapper}>
          <div>
            <h1>IVM Immobilienverwaltung Meyer GmbH</h1>
            <h2>Verkauf – Vermietung – Verwaltung</h2>
            <div>
              <Link simple name="MEHR ERFAHREN" tag="h4" onClick={() => scrollToElement('#mehr')} />
              <Link simple name="KONTAKT AUFNEHMEN" tag="h4" onClick={() => scrollToElement('#kontakt')} />
            </div>
          </div>
        </div>
      </Element>
      <Element name="ueberuns">
        <Blocks headerTag="h1" content={ueberuns} />
      </Element>
      <Element name="mehr">
        <Element name="verkauf">
          <Blocks
            headerTag="h2"
            content={[{ ...verkauf[0], onMore: () => navigateTo('/verkauf'), onContact: () => scrollToElement('#kontakt') }, { image: verkaufImage.file.url }]}
          />
        </Element>
        <Element name="verwaltung">
          <Blocks
            headerTag="h2"
            content={[{ image: verwaltungImage.file.url }, { ...verwaltung[0], onMore: () => navigateTo('/verwaltung'), onContact: () => scrollToElement('#kontakt') }]}
          />
        </Element>
      </Element>
    </div>
  );
};

Home.propTypes = {
  pathContext: PropTypes.shape({
    subparts: PropTypes.array.isRequired,
    images: PropTypes.array.isRequired,
    references: PropTypes.array.isRequired,
  }),
};

export default Home;



// WEBPACK FOOTER //
// ./src/templates/page.home.js